Ext.define('SA.lq.view.ToolbarFactory', {
    singleton: true,

    create() {
        var locationsCombo = Ext.widget({xtype: 'lq-locations-combo'}),
            geoUnitsCombo = Ext.widget({
                xtype: 'combo-button',
                textField: 'text',
                ui: 'underline',
                valueField: 'value'
            }),
            editViewMenuItem = Ext.widget({xtype: 'menuitem', text: 'Edit View'}),
            deleteViewMenuItem = Ext.widget({xtype: 'menuitem', text: 'Delete View'}),
            exportBtn = Ext.widget({
                xtype: 'sa-button',
                cls: 'sa-pvt-export-button',
                icon: 'sa-icon-export',
                margin: '0 10 0 10',
                text: 'Export',
                width: 85
            });

        return Ext.widget({
            xtype: 'simple-container',
            cls: 'sa-toolbar',

            cmps: {
                locationsCombo,
                geoUnitsCombo,
                editViewMenuItem,
                deleteViewMenuItem,
                exportBtn
            },

            items: [
                {
                    xtype: 'pvt-text',
                    cls: 'sa-lq-toolbar-find-all-text',
                    text: 'Find all'
                },
                geoUnitsCombo,
                {
                    xtype: 'pvt-text',
                    text: 'in'
                },
                locationsCombo,
                {
                    xtype: 'pvt-text',
                    text: 'that match the following conditions:'
                }, {
                    xtype: 'pvt-fill'
                }, {
                    xtype: 'sa-menu-button',
                    text: 'View Actions',

                    menu: {
                        xtype: 'menu',
                        items: [editViewMenuItem, {xtype: 'menuseparator'}, deleteViewMenuItem]
                    }
                },
                exportBtn
            ]
        });
    }
});